module.exports = __webpack_public_path__ + "files/9e3aea4c12078c9a52e9986baaa41243.png";